import React from "react";
import { Building, Users, BarChart3 } from "lucide-react";
import AudienceLanding from "../components/AudienceLanding";

export default function Business() {
  return (
    <AudienceLanding
      audienceSlug="business"
      landingParam="business"
      registerAudienceParam="business"
      testidPrefix="business-landing"
      hero={{
        overline: "PREMIUM AI ACADEMY FOR BUSINESS TEAMS",
        headline: (
          <>
            Train your team<br/>
            to use AI <span className="text-fc-red">at work.</span>
          </>
        ),
        subhead: "Practical AI workflows for marketing, sales, ops, and service teams. No fluff. Just shippable upgrades to the work you're already doing.",
        heroImage: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=2000&q=80",
      }}
      stats={[
        { icon: Building, value: "300+", label: "Companies" },
        { icon: Users, value: "8,500+", label: "Teammates Onboarded" },
        { icon: BarChart3, value: "27%", label: "Avg Time Saved" },
      ]}
      testimonials={[
        { name: "Lena Rodriguez", role: "VP People, Northbrook Group", quote: "Our entire 80-person team finished the AI 101 course in one quarter. Knowledge gap closed, productivity up." },
        { name: "Owen Brady", role: "Head of Marketing, Ferrite Inc.", quote: "We replaced one $80k retainer with a Friday-afternoon workflow built inside Make.com. ROI within month one." },
        { name: "Priya Singh", role: "Director of Ops, BluePeak", quote: "I send every new manager to the prompt engineering course. It pays for itself the first week." },
      ]}
      featuredHeadline={
        <>Where teams <span className="text-fc-red">level up.</span></>
      }
    />
  );
}
